import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useDropzone } from "react-dropzone";
import CustomButton from "components/Fileds/CustomButton";

const AddPhotosModal = ({ open, onClose, onUpload, type, isLoading }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);

    const onDrop = (acceptedFiles) => {
        setSelectedFiles(prev => [...prev, ...acceptedFiles]);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/*': ['.jpeg', '.jpg', '.png']
        }
    });

    const handleUpload = async () => {
        if (selectedFiles.length === 0) return;

        const formData = new FormData();
        // Append text fields BEFORE files for multer req.body access
        formData.append("upload_type", "restaurant_photos");
        formData.append("photo_type", type);

        selectedFiles.forEach(file => {
            formData.append("files", file);
        });

        await onUpload(formData);
        setSelectedFiles([]);
        onClose();
    };

    const handleClose = () => {
        setSelectedFiles([]);
        onClose();
    };

    const photoLabel = type === 'food' ? "Food" : "Ambience";

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: "12px", p: 1 }
            }}
        >
            <DialogTitle sx={{ m: 0, py: 1, px:2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Add {photoLabel} Photos
                </Typography>
                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Box
                    {...getRootProps()}
                    sx={{
                        border: '2px dashed #ccc',
                        borderRadius: '12px',
                        py: 8,
                        textAlign: 'center',
                        cursor: 'pointer',
                        backgroundColor: isDragActive ? '#f0f7ff' : '#fafafa',
                        borderColor: isDragActive ? '#1976d2' : '#ccc',
                        mb: 2,
                        transition: 'all 0.2s'
                    }}
                >
                    <input {...getInputProps()} />
                    <Box sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        backgroundColor: '#eee',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                        mb: 2
                    }}>
                        <FileUploadIcon color="action" />
                    </Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        Click to upload photos
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Select multiple images at once
                    </Typography>
                </Box>

                {selectedFiles.length > 0 && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="primary.main">
                            {selectedFiles.length} file(s) selected
                        </Typography>
                    </Box>
                )}

                <CustomButton
                    fullWidth
                    onClick={handleUpload}
                    loading={isLoading}
                    disabled={selectedFiles.length === 0}
                    height="44px"
                    sx={{ borderRadius: '8px' }}
                >
                    Upload Photos
                </CustomButton>
            </DialogContent>
        </Dialog>
    );
};

export default AddPhotosModal;
